module.exports = __webpack_public_path__ + "img/12 Animation 2-squashed.9ae75b2d.jpg";